import { Injectable } from '@angular/core';
import { ISelectable } from '../../src/typings/models';
import { ISelectableService } from '../../src/typings/services';

@Injectable({
    providedIn: 'root'
})
export class SelectableService implements ISelectableService {
    public static $name = 'selectableService';

    public getSelected<T extends ISelectable>(items: T[]) {
        return items.filter((item: T) => item.selected);
    }

    /**
     * Use short-circuit logic to end the loop if an item is found!
     * @param items An array of items which may or may not be selected
     */
    public hasSelected(items: ISelectable[]) {
        return items.some((item: ISelectable) => item.selected);
    }

    public hasAllSelected(items: ISelectable[]) {
        return items.every((item: ISelectable) => item.selected);
    }
}
